export default "__VITE_ASSET__B3OVX0vG__"